// Async boundary for Module Federation
console.log('[Shell] Starting BNI Move Shell...');
console.log('[Shell] Time:', new Date().toISOString());
console.log('[Shell] Module Federation - Dynamic Loading Enabled');
console.log('[Shell] No MFEs will be loaded until their routes are accessed!');
console.log('[Shell] Open Network tab and navigate to different routes to see lazy loading in action');
// Wait for env-sync to complete before bootstrapping app
console.log('[Shell] Waiting for environment sync to complete...');
function waitForEnvSync() {
    return new Promise((resolve) => {
        // Check if env-sync already completed
        if (window.__envSyncComplete) {
            console.log('[Shell] Environment sync already complete');
            resolve();
            return;
        }
        // Poll for completion with timeout
        const startTime = Date.now();
        const timeout = 10000; // 10 seconds max wait
        const checkInterval = setInterval(() => {
            if (window.__envSyncComplete) {
                console.log('[Shell] Environment sync completed');
                clearInterval(checkInterval);
                resolve();
            }
            else if (Date.now() - startTime > timeout) {
                console.warn('[Shell] Environment sync timeout - proceeding anyway');
                clearInterval(checkInterval);
                resolve();
            }
        }, 50); // Check every 50ms
    });
}
waitForEnvSync().then(() => {
    console.log('[Shell] Starting app bootstrap...');
    import('./bootstrap');
});
export {};
